import { cn } from "@/modules/lib/utils"
import { ProgramInformation } from "@modules/programs/components/programHeader/programInformation"
import { useProgram } from "@modules/programs/hooks/usePrograms"

type ProgramHeaderCenterViewProps = {
  programId: string
  className?: string
} & React.ComponentProps<"div">

export function ProgramHeaderCenterView({ programId, className, ...props }: ProgramHeaderCenterViewProps) {
  const { data: program } = useProgram(programId)

  return (
    <div
      className={cn(
        "relative flex flex-1 flex-row overflow-hidden rounded-4xl border-0 bg-linear-to-r from-secondary-900 to-secondary-700",
        className,
      )}
      {...props}
    >
      {program && <ProgramInformation programId={programId} className="z-2" />}
      <span
        className="absolute inset-0 z-1 block rounded-4xl bg-cover bg-center opacity-20 blur-xs"
        style={{
          backgroundImage: `url(${program?.image?.url})`,
        }}
      ></span>
    </div>
  )
}
